import {Comment} from 'client';

export type PendingDeleteCommentIds = Record<string, true>;

const isRenderableComment = (comment: Comment) => comment.content.length > 0 && !comment.is_deleted;

export const getCommentRenderState = (
  comments: Comment[] | undefined,
  pendingDeleteCommentIds: PendingDeleteCommentIds
) => {
  const renderableComments = comments?.filter(isRenderableComment) ?? [];
  const activeComments = renderableComments.filter(
    (comment) => !pendingDeleteCommentIds[comment.id]
  );
  const pendingDeleteComments = renderableComments.filter(
    (comment) => pendingDeleteCommentIds[comment.id]
  );

  return {
    activeComments,
    pendingDeleteComments,
    commentsToRender: activeComments.length > 0 ? activeComments : pendingDeleteComments,
    firstRenderableComment: activeComments[0] ?? pendingDeleteComments[0],
    latestActiveComment: activeComments[activeComments.length - 1],
    latestPendingDeleteComment: pendingDeleteComments[pendingDeleteComments.length - 1],
    isDeletingLastComment: activeComments.length === 0 && pendingDeleteComments.length > 0,
    replyCount: Math.max(activeComments.length - 1, 0),
  };
};
